
import { h, Component } from 'preact';
import style from './style.less'
import dayjs from 'lib/helpers/dayjs';

export default (props)=>{
    let timeSlotSytle = style.timeSlot
    if(props.selected){
        timeSlotSytle += ` ${style.selected}`
    }
    return (
        <div key={props.id} class={timeSlotSytle} onClick={props.onSelect} id={props.id}>
            {dayjs(props.startsAt).format("hh:mm A")}
        </div>
    )
}


// WEBPACK FOOTER //
// ./components/elements/TimeSlot/index.js